<template>
  <header class="header-global">
    <base-nav class="navbar-main position-fixed bg-white z-20" transparent type="" effect="" expand>
      <ul class="navbar-nav  align-items-center  ">
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="#">
            紫微飛星
          </a>
        </li>
      </ul>
      <ul class="navbar-nav  align-items-center ml-lg-auto ">
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  data() {
    return {
      isHomePage: true,
    }
  },
  created() {
    this.isHomePage = this.$route.path === '/';
  },
  methods: {
    clickAnchor(target) {
      const element = document.getElementById(target);
      if (this.isHomePage) {
        element.scrollIntoView({behavior: 'smooth'});
      } else {
        this.$router.push({path: '/', hash: target},);
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.z-20 {
  z-index: 20;
}

</style>
